import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PictureInPictureIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// No design-library glyph exists for picture-in-picture yet. Drawn from the Lucide
// "picture-in-picture-2" glyph scaled to the 20×20 icon grid (stroke 1.5, round caps)
// to match Foundation iconography. Replace with the library asset when one lands.
export const PictureInPictureIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: PictureInPictureIconProps) => {
  const resolvedColor =
    color ??
    tokenVar(
      colorScheme === 'light'
        ? 'colors.light.icon.secondary'
        : 'colors.icon.secondary'
    )
  return (
    <svg
      aria-label='Enable picture in picture'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.5 7.5V5C17.5 4.0795 16.7538 3.3333 15.8333 3.3333H3.3333C2.4129 3.3333 1.6667 4.0795 1.6667 5V13.3333C1.6667 14.2538 2.4129 15 3.3333 15H6.6667'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <rect
        height='5.8333'
        rx='1.6667'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        width='8.3333'
        x='10'
        y='10.8333'
      />
    </svg>
  )
}
